<template>
  <div class="template info-con" @click="hideMore">
    <div class="tmp-title nav-title">
      <div class="tt-left">
        <h2>
          企业模板
          <action-tips>
            <template slot="tips">
              <p>可以通过2种方式创建团队模版：</p>
              <p>1、浏览爱设计提供的模板，并将选中的模板设为团队模板。</p>
              <p>2、自行通过PS设计模板，将psd文件上传后设置为团队模板。</p>
            </template>
          </action-tips>
        </h2>
      </div>
      <div class="tt-right" v-if="loginInfo.current_team_role !== 4">
        <el-button type="primary" @click="newFolder">新建文件夹</el-button>
        <el-button type="primary" @click="uploadPsdOpen">上传模板</el-button>
      </div>
    </div>
    <div class="tmp-con">
      <ActionBread :breadList="breadList"></ActionBread>
      <div class="template-list">
        <ul class="flex-image-folder--box">
          <template v-for="item in templateInfo.template_directory">
            <ActionFolder :item="item" :key="item.id"></ActionFolder>
          </template>
        </ul>
        <ul
          class="flex-image-folder--box"
          v-if="templateInfo && templateInfo.templates"
        >
          <template v-for="item in templateInfo.templates.data">
            <ActionImage
              :key="item.id"
              :item="item"
              :status="true"
              :type="'template'"
              :collect="true"
            ></ActionImage>
          </template>
        </ul>
        <Pagination
          v-if="Pagination.total > Pagination.page_size"
          @handleCurrentChange="handleCurrentChange"
          :Pagination="Pagination"
        />
      </div>
    </div>
    <MoveFolder @submit="moveSubmit" ref="move" />
    <!--重命名和新建-->
    <RenameDialog
      ref="renameDialog"
      :title="moreInfo && moreInfo.team_id ? '重命名' : '新建文件夹'"
      @submit="editFolder"
    />
    <!--删除模板和文件夹-->
    <RemoveDialog
      :title="
        moreInfo && Object.keys(moreInfo).includes('cover_url')
          ? '是否确认删除该模板'
          : '是否确认删除该文件夹'
      "
      @remove="removeFolder"
    />
    <!--上传psd弹出框-->
    <Psd
      :teamid="loginInfo && loginInfo.current_team_id"
      :dirid="dir_id"
      :source="'space'"
    />
    <!--团队过期弹出框-->
    <expireTeamDialog />
    <WriteInfo v-if="writeInfoVisable"/>
  </div>
</template>

<script>
import { Template, Member } from "@/config/axios/new_api";
import Psd from "../Space/psd.vue";
import Index from "@/config/mixin/index.js";
import RemoveDialog from "@/components/dialog/removeDialog.vue";
import RenameDialog from "@/components/dialog/renameDialog.vue";
import MoveFolder from "@/components/dialog/moveFolder.vue";
import ActionFolder from "@/components/actionContent/folder";
import ActionImage from "@/components/actionContent/image";
import ActionTips from "@/components/actionContent/titleTips";
import ActionBread from "@/components/actionContent/bread";
import WriteInfo from "@/components/dialog/writeInfo.vue";
export default {
  components: {
    Psd,
    RemoveDialog,
    RenameDialog,
    MoveFolder,
    ActionFolder,
    ActionImage,
    ActionTips,
    ActionBread,
    WriteInfo
  },
  mixins: [Index],
  data() {
    return {
      breadList: [],
      templateInfo: {},
      moreInfo: null,
      moreStatus: false,
      renameStatus: false,
      moveDialogStatus: false,
      removeDialogStatus: false,
      renameInput: "",
      dir_id: 0,
      props: {
        label: "name",
        children: "zones",
        isLeaf: "is_empty",
      },
      Pagination: {
        total: 0,
        page: 1,
        page_size: 25,
      },
      folderTree: {},
      uploadPsdStatus: false,
      fontremoveenable: false,
      writeInfoVisable: false,
    };
  },
  computed: {
    teamList() {
      return this.$store.getters.teamList; // 后期直接使用domani
    },
    loginInfo() {
      return this.$store.getters.loginInfo;
    },
  },
  created() {
    if(this.$route.query.folder) {
      this.dir_id = parseInt(this.$route.query.folder.split('_')[1]);
    }
    this.getData();
    if (tokenFunc.getToken()) {
      this.getCurrentTeam();
    }
  },
  watch: {
    $route(val,old){
      this.dir_id = val.query.folder ? parseInt(val.query.folder.split('_')[1]) : 0;
      if(this.dir_id == 0) {
        this.breadList = [];
      }
      this.getData();
    }
  },
  methods: {
    async getCurrentTeam() {
        let res = await Member.getCurrentTeam()
        if (res.status == 1) {
            this.writeInfoVisable = res.data.corp_id && !this.loginInfo.nick_name
        }
    },
    getData(
      data = {
        dir_id: this.dir_id,
        per_page: this.Pagination.page_size,
        page: this.Pagination.page,
      }
    ) {
      Template.templates(data).then((res) => {
        if (res.data.id) {
          if(this.$route.query.folder && this.$route.query.folder.split('_')[1] == res.data.current_team.current_dir_id) {
            this.breadList = [{name: res.data.current_team.dir_name, id: res.data.current_team.current_dir_id}]
          }
          this.templateInfo = res.data.current_team;
          this.Pagination.total = res.data.current_team.templates.total;
          let templates = this.templateInfo.templates;
          //如果当前页已没有数据则请求上一页
          if (templates.total > 0) {
            if (templates.current_page > 1 && templates.data.length === 0) {
              this.getData({
                dir_id: this.dir_id,
                per_page: this.Pagination.page_size,
                page: templates.current_page - 1,
              });
            }
          }
        }
      });
    },
    psdClose() {
      this.uploadPsdStatus = false;
    },
    renameClick() {
      let res = this.expireHandle();
      if(res){
        this.renameStatus = true;
        this.moreStatus = false;
      }
    },
    moreShow(item) {
      this.moreInfo = item;
      this.renameInput = item.name;
      this.moreStatus = !this.moreStatus;
    },
    hideMore() {
      // this.moreInfo = null;
      this.moreStatus = false;
    },
    editFolder() {
      // 修改文件夹名称  新建文件夹
      let rename = this.$refs.renameDialog.renameObj.renameInput;
      if (this.moreInfo && this.moreInfo.team_id) {
        if (Object.keys(this.moreInfo).includes("cover_url")) {
          Template.renameTemplate(
            {
              team_template_id: this.moreInfo.id,
              rename,
              team_id: this.moreInfo.team_id,
              type: "template",
            },
          ).then((res) => {
            if (res.status == 1) {
              this.$message.success("修改成功");
              this.moreInfo = null;
              // this.renameInput = "";
              this.renameStatus = false;
              this.getData();
            }
          });
        } else {
          // 修改文件夹信息
          Template.renameDir(
            {
              team_id: this.moreInfo.team_id,
              dir_name: rename,
              dir_id: this.moreInfo.id,
            },
            "PATCH"
          ).then((res) => {
            if (res.status === 1) {
              this.$message.success("修改成功");
              this.moreInfo = null;
              // this.renameInput = "";
              this.renameStatus = false;
              this.getData();
            }
          });
        }
      } else {
        Template.createDir(
          {
            team_id: this.loginInfo.current_team_id,
            dir_name: rename,
            dir_id: this.dir_id,
          },
        ).then((res) => {
          if (res.status == 1) {
            this.$message.success("新增成功");
            this.moreInfo = null;
            this.renameInput = "";
            this.renameStatus = false;
            this.getData();
          }
        });
      }
    },
    removeDialogOpen() {
      let res = this.expireHandle();
      if(res){
        this.removeDialogStatus = true;
      }
    },

    newFolder() {
      let res = this.expireHandle();
      if (res) {
        this.renameInput = "";
        this.moreInfo = null;
        this.renameStatus = true;
      }
    },
    collect(item) {
      let res = this.expireHandle();
      if (res) {
        Template.collect({
          team_template_id: item.id,
          team_id: this.loginInfo.current_team_id,
        }).then((res) => {
          if (res.status === 1) {
            this.$message.success("收藏成功");
            this.moreStatus = false;
          }
        });
      }
    },
    moveTemp() {
      // 点击移动按钮
      let res = this.expireHandle();
      if(res){
        this.moveDialogStatus = true;
        this.$nextTick(()=>{
            let node = this.$refs.move.$refs.tree.getNode(0)
            node.loaded = false
            node.expand()
        })
      }
    },
    loadNode(node, resolve) {
      if (node.level === 0) {
        return resolve([{ name: "全部", id: 0 }]);
      }
      if (node.level > 1) {
        let dir_id = node.data.id;
        Template.getDir(
          {
            team_id: this.moreInfo.team_id,
            dir_id,
          },
          "GET"
        ).then((res) => {
          resolve(res.data);
        });
      }
      if (node.level === 1) {
        // 二级节点
        Template.getDir(
          {
            team_id: this.moreInfo.team_id,
            dir_id: 0,
          },
        ).then((res) => {
          resolve(res.data);
        });
      }
    },
    moveTreeClick(data) {
      // 弹出框打开
      this.folderTree = data;
    },
    moveSubmit() {
      Template.move({
        type: "template",
        dir_id: this.folderTree.id,
        team_template_id: this.moreInfo.id,
        team_id: this.moreInfo.team_id,
      }).then((res) => {
        if (res.status === 1) {
          this.$message.success('操作成功');
          this.moveDialogStatus = false;
          this.getData();
        }
      });
    },
    closeMove() {
      this.moveDialogStatus = false;
    },
    removeFolder() {
      if (Object.keys(this.moreInfo).includes("cover_url")) {
        Template.delete({
          type: "template",
          team_template_id: this.moreInfo.id,
          team_id: this.moreInfo.team_id,
        }).then((res) => {
          this.removeDialogStatus = false;
          this.moreInfo = null;
          if (res.status === 1) {
            this.$message.success("删除成功");
            this.removeDialogStatus = false;
            this.getData();
          }
        });
      } else {
        // 删除文件夹
        Template.deleteDir(
          {
            team_id: this.moreInfo.team_id,
            dir_id: this.moreInfo.id,
          },
        ).then((res) => {
          this.removeDialogStatus = false;
          this.moreInfo = null;
          if (res.status === 1) {
            this.$message.success("删除成功");

            this.getData();
          }
        });
      }
    },
    goDetail(item) {
      // 进入文件夹详情
      if (item === 0) {
        this.dir_id = item;
        this.breadList = [];
        this.getData({ dir_id: 0, per_page: 25, page: 1 });
      } else {
        let index = null;
        for (let i = 0; i < this.breadList.length; i++) {
          if (this.breadList[i].id === item.id) {
            index = i;
          }
        }
        if (index === null) {
          this.breadList.push(item);
        } else {
          this.breadList.splice(index + 1, this.breadList.length);
        }
        this.dir_id = item.id;
        this.getData({ dir_id: item.id, per_page: 25, page: 1 });
      }
    },
    uploadPsdOpen() {
      const href = `/enterprise-design-v1?f=qiye&mode=4&ckey=custom&nature=team`
      window.location.href = href
      // let res = this.expireHandle();
      // if (res) {
      //   this.uploadPsdStatus = true;
      // }
    },
  },
};
</script>

<style lang="scss" scoped>
.template {
  padding: 0 24px;
}
.move-main {
  @include wh(440px, 302px);
  border: 1px solid #e1e1e1;
  margin: 0 auto;
  padding: 16px 8px 11px 0;
  overflow: hidden;
  border-radius: 8px;
}
</style>
